import { useRef } from 'react';

import { Dialog, DialogHandle } from 'components/modal_manager';
import { FormattedMessage, useIntl } from 'react-intl';

import 'components/error_boundary/styles/ErrorBoundary.scss';

import { Button } from 'react-bootstrap';

type ErrorFallbackProps = {
    error: Error;
    errorInfo: React.ErrorInfo;
};

export const ErrorFallback = (props: ErrorFallbackProps) => {

    const { formatMessage } = useIntl();

    const { error, errorInfo } = props;

    const dialogRef = useRef<DialogHandle>();

    const handleShowDetails = () => {

        const dialog = dialogRef?.current;
        if (!dialog) return;

        dialog.show({
            actions: [
                dialog.SingleOKAction()
            ],
            body: (
                <pre className="error-boundary-stacktrace p-3 border border-danger-subtle rounded text-muted overflow-auto">
                    <strong className={'text-danger'}>
                        {error.name}
                    </strong>
                    <br/>
                    {error.stack}
                    <br/>
                    <strong className={'text-body'}>
                        {'Component Stack:'}
                    </strong>
                    {errorInfo.componentStack}
                </pre>
            ),
            title: formatMessage({ id: 'error_details.338ff601', defaultMessage: 'Error Details' })
        });

    };

    return (
        <div className="error-fallback d-flex flex-column flex-md-row align-items-center justify-content-center h-100 p-5 gap-5 text-center text-md-start">
            <div>
                <i className="fa-light fa-circle-exclamation error-boundary-icon text-danger mb-3" />
            </div>

            <div className={'d-flex flex-column gap-3'}>
                <h1 className="display-6 mb-2">
                    <FormattedMessage defaultMessage="Something went wrong" id="something_went_wrong.81545628" />
                </h1>

                <p className="text-muted">
                    <FormattedMessage defaultMessage="An error has occurred, try again or contact us for further assistance" description="Mensaje" id="an_error_has_occurred_try_again_or_conta.b1a18880" />
                </p>

                <div className={'d-flex flex-column flex-md-row gap-3 justify-content-between align-items-center align-items-md-start'}>
                    <div className={'d-flex gap-1'}>
                        <Button className={'align-self-center'} onClick={handleShowDetails} size={'sm'} variant={'secondary'}>
                            <FormattedMessage defaultMessage="View Details" id="view_details.fa7bb04a" />
                        </Button>
                        <Button className={'align-self-center'} onClick={() => location.reload()} size={'sm'}>
                            <FormattedMessage defaultMessage="Reload" id="reload.91649189" />
                        </Button>
                    </div>
                    <Button href={`https://support.gmetrix.net`} rel={'noopener noreferrer'} size={'sm'} target={'_blank'} variant={'link'}>
                        <FormattedMessage defaultMessage="Contact Support" id="contact_support.fa90777b" />
                    </Button>
                </div>

            </div>

            <Dialog ref={dialogRef} size={'lg'} />

        </div>
    );

};
